<template>
  <div>
    <h4>SymDB content</h4>
    <div v-if="loaded && isLoggedIn" class="grid-container">
      <b-link target="_blank" @click="exportExcel">Download</b-link><br />
      Click on the right of a column to filter data.
      <ag-grid-vue
        ref="grid"
        class="ag-theme-balham symdbcontent"
        :column-defs="columnDefs"
        :row-data="rowData"
        :default-col-def="defaultColDef"
        :grid-options="gridOptions"
        @gridReady="onGridReady"
      >
      </ag-grid-vue>
    </div>
    <div v-else>
      <b-alert show variant="danger">{{ message }}</b-alert>
      <b-button @click="load">Reload</b-button>
    </div>
  </div>
</template>
<script>
import { AgGridVue } from 'ag-grid-vue';
import Vue from 'vue';

export default {
  name: 'App',
  components: {
    AgGridVue,
  },

  data() {
    return {
      columnDefs: null,
      rowData: null,
      defaultColDef: { filter: true, sortable: true },
      loaded: false,
      message: 'Table not available (are you logged ?)',
      gridApi: null,
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
  },
  watch: {
    isLoggedIn() {
      this.load();
    },
  },

  mounted() {
    this.load();
  },
  methods: {
    load() {
      Vue.http
        .post('api/getContentMetadataFile', {
          login: this.$store.getters.getLogin,
          token: this.$store.getters.getToken,
        })
        .then(
          resp => {
            const data = resp.body;
            if (data != null) {
              if (data.success == true) {
                this.columnDefs = data.columnDefs;
                this.rowData = data.rowData;
                this.loaded = true;
              } else {
                this.message = data.message;
              }
            } else {
              this.message = 'Server error';
            }
          },
          () => {
            this.message = 'Server error';
          }
        );
    },
    exportExcel() {
      this.gridApi.exportDataAsCsv();
    },
    onGridReady(params) {
      this.gridApi = params.api;
    },
  },
};
</script>

<style>
.symdbcontent {
  width: 100%;
  height: 400px;
  /* min-width: 1800px;  */
}

.grid-container {
  display: flex;
  flex-direction: column;
}
</style>
